import React__default from 'react';
import { useTranslation } from 'react-i18next';
import KDialog from '../../../KDialog/index.js';
import { withSuspense } from '../../../withSuspense/index.js';

var BasketDelete = function (_a) {
    var open = _a.open, close = _a.close, currentBasketTitle = _a.currentBasketTitle, deleteBasket = _a.deleteBasket, numberOfBaskets = _a.numberOfBaskets;
    var t = useTranslation("refront-components").t;
    var multipleBaskets = numberOfBaskets > 1;
    return (React__default.createElement(KDialog, { className: "BasketDelete", open: open, actionLabel: t("components.action.delete"), cancelLabel: t("components.action.cancel"), titleLabel: multipleBaskets
            ? t("components.baskets.delete.title.label")
            : t("components.basket.delete.title.label"), dialogContentText: multipleBaskets
            ? t("components.baskets.delete.text.label", { count: numberOfBaskets })
            : currentBasketTitle
                ? t("components.basket.delete.text.label", { title: currentBasketTitle })
                : t("components.basket.delete.text.label", { title: "" }), handleClose: close, handleAction: deleteBasket, testId: "BasketDelete" }));
};
var index = withSuspense(BasketDelete);

export { index as default };
//# sourceMappingURL=index.js.map
